import axios from 'axios';
import requests from './httpService';

const getAuthHeaders = () => {
  const token = localStorage.getItem('id_token');
  return token ? { authorization: `Bearer ${token}` } : {};
};

const ImagesStoreService = {
  createImagesStore(body) {
    return requests.post('/imagesstore/add', body);
  },
  findImagesStoreList(body) {
    return requests.post('/imagesstore/find', body);
  },
  getImagesStoreById(id) {
    return requests.get(`/imagesstore/${id}`);
  },
  updateImagesStore(id, body) {
    return requests.put(`/imagesstore/${id}`, body);
  },
  deleteImagesStore(id) {
    return requests.delete(`/imagesstore/${id}`);
  },

  /**
   * Upload multiple images in one request (multipart field "images").
   * Returns { uploadId, total, pollUrl } — then poll getUploadProgress.
   * onSendProgress: ({ phase: 'sending', percent, loaded, total }) while sending to server.
   */
  /**
   * @param {FormData} formData — append files as "images"; optional field "containerName"
   * @param {Function} [onSendProgress]
   */
  uploadImagesBatch(formData, onSendProgress) {
    const baseURL = requests.baseURL();
    return axios
      .post(`${baseURL}/imagesstore/uploadimages`, formData, {
        headers: getAuthHeaders(),
        onUploadProgress: (event) => {
          if (!onSendProgress || !event.total) return;
          onSendProgress({
            phase: 'sending',
            loaded: event.loaded,
            total: event.total,
            percent: Math.min(100, Math.round((event.loaded * 100) / event.total)),
          });
        },
      })
      .then((response) => response.data);
  },

  /** Poll Azure upload progress (Flutter: GET same URL every ~400ms until status is done/failed). */
  getUploadProgress(uploadId) {
    return requests.get(`/imagesstore/uploadprogress/${uploadId}`);
  },

  /** Delete one image from Azure by full URL and/or blob imageName. */
  deleteAzureImage(body) {
    return requests.post('/imagesstore/deleteazureimage', body);
  },
};

export default ImagesStoreService;
